'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitialOnlineConversation = exports.default = undefined;

var _reselect = require('reselect');

var _getConversations = require('./conversationSelectors/getConversations');

var _stubbedChannel = require('../threads/constants/stubbedChannel');

var getInitialOnlineConversation = (0, _reselect.createSelector)([_getConversations.getConversations], function (conversations) {
  return conversations.get(_stubbedChannel.STUBBED_CHANNEL);
});

// Ensure that defaults are properly exported.  asset-bender will munge the defaults
exports.default = getInitialOnlineConversation;
exports.getInitialOnlineConversation = getInitialOnlineConversation;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/getInitialOnlineConversation.js
// module id = 646
// module chunks = 2 3